import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { BreadcrumbContainer, Navigator } from "../";
import Header from "../Header/Header";
import HeaderScrolled from "../HeaderScrolled/HeaderScrolled";
import { SectionShellContainer } from "./SectionShell.styled";
import { useContacts } from "../../context/ContactsContext";

const Sentinel = styled.div`
  height: 1px;
`;

const Spacer = styled.div`
  height: ${(p) => p.h || 0}px;
`;

const SectionShell = ({ children }) => {
    const [showCompact, setShowCompact] = useState(false);
    const [barH, setBarH] = useState(0);
    const sentinelRef = useRef(null);
    const barRef = useRef(null);
    let debounceTimer = useRef(null);
    const { contactId } = useParams();
    const { fetchContactDetails, clearContactDetails } = useContacts();

    useEffect(() => {
        if (!sentinelRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const isVisible = entries[0].isIntersecting;

                if (debounceTimer.current) clearTimeout(debounceTimer.current);
                debounceTimer.current = setTimeout(() => {
                    setShowCompact(!isVisible);
                }, 30);
            },
            {
                root: null,
                threshold: 0,
                rootMargin: "-8px 0px 0px 0px", 
            }
        );

        observer.observe(sentinelRef.current);
        return () => {
            observer.disconnect();
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
        };
    }, []);

    useLayoutEffect(() => {
        const measure = () => {
            if (barRef.current) setBarH(barRef.current.offsetHeight || 0);
        };
        measure();
        window.addEventListener("resize", measure);
        return () => window.removeEventListener("resize", measure);
    }, []);

    // Load contact data when contactId is present in URL
    useEffect(() => {
        if (contactId) {
            // Reset contact state before loading new contact to avoid showing previous contact data
            clearContactDetails();
            fetchContactDetails(contactId);
        }
    }, [contactId, fetchContactDetails, clearContactDetails]);

    return (
        <>
            
            <SectionShellContainer $show={showCompact} ref={barRef}>                
                <BreadcrumbContainer />
                <HeaderScrolled />
            </SectionShellContainer>
            
            {showCompact ? <Spacer h={barH} /> : null}
            
            {!showCompact && <BreadcrumbContainer />}            

            <Navigator />
            <Sentinel ref={sentinelRef} />
            <Header />

            {children}
        </>
    );
};

export default SectionShell;
